import PopupDICOMTags from "./PopupDICOMTags";
export default PopupDICOMTags;
